var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTimelineFarewell(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#380116",
    strokeWidth: 2.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29 87 100 37l71 50v72c0 5-3 8-8 8H37c-5 0-8-3-8-8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48 100V59h104v41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m30 89 53 38m87-38-53 38M31 162l58-42c6-4 16-4 22 0l58 42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100 107c-4-4-16-11-16-18 0-9 11-11 16-4 5-7 16-5 16 4 0 7-12 14-16 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62 71h22m32 0h22M19 63l-6-5m13-5-2-8m156 18 6-5m-13-5 2-8",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineFarewell);
export default __webpack_public_path__ + "static/media/timeline-farewell.80bc4681d73a14ab221e350c2db1ffe9.svg";
export { ForwardRef as ReactComponent };